module.exports = __webpack_public_path__ + "static/media/rams-campaign-billboard.c7e8a595.png";